const validateFactor = (factor: number) => {
  const ALLOWED_VALUES = new Set([0, 0.5, 1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 8.5, 10, 12, 14, 16, 18, 20, 24, 32, 40])
  if (!ALLOWED_VALUES.has(factor)) {
    console.warn(`Invalid spacing factor: ${factor}. Allowed values are: ${[...ALLOWED_VALUES].join(', ')}`)
  }
}

export const spacing = (factor: number): string => {
  if (factor < 0) {
    return `-${spacing(-factor)}`
  }

  if (process.env.NODE_ENV !== 'production') {
    validateFactor(factor)
  }

  const space = factor * 0.25
  return `${space}rem`
}
